import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../layout/layout.component';
import { ToastrService } from 'ngx-toastr';
import { PageEvent } from '@angular/material';
import { ComponentSearchFields } from '../../common/viewModels/GlobalRegistry/SampPointModel';
import { PagerService } from '../../common/pagerService';
declare var $: any;

@Component({
    selector: 'components',
    templateUrl: './components.component.html',
    styleUrls: ['./components.component.scss']
})
export class ComponentsComponent implements OnInit {
    componentForm: FormGroup;
    componentsSearchForm: FormGroup;
    id: number;
    searchFields: ComponentSearchFields = new ComponentSearchFields();
    isNoRecords: boolean = true;
    isSubmitted: boolean = false;
    pager: any = {};
    pagedItems: any[];
    length: number = 0;
    pageEvent: PageEvent;
    mainComponent: any;
    pageSize: number = 10;
    constructor(public _router: Router, private _formBuilder: FormBuilder, private _pagerService: PagerService,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute,
        private _mApp: MainAppComponent, private _toastrService: ToastrService,
    ) {
        this.mainComponent = _mApp;
    }

    ngOnInit() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
        this.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
        this.pager.pageSize = this.pageSize;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
        this.CreateForm();
        this.componentsSearchForm = this._formBuilder.group({
            Name: ['']
        });
        this.setPage(this.pager);
    }

    CreateForm() {
        this.componentForm = this._formBuilder.group({
            ComponentId: [0],
            Name: ['', Validators.compose([Validators.required,Validators.minLength(1),Validators.maxLength(50)])]
        });
    }
    GetComponentsById(id: number) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetComponentById + id)
            .subscribe(
            m => {
                this._mApp.HideLoader();
                if (m.json().Result != null) {
                    this.componentForm.setValue(m.json().Result);
                }
            }, error => {
                this._mApp.HideLoader();
                this._toastrService.error(error.json().Result, '');
            }
            )
    }
    DeleteComponent(id: any) {
        this.id = id;
    }
    DeleteComponentById(id: number) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.DeleteComponent + id)
            .subscribe(
            res => {
                this._mApp.HideLoader();
                this.setPage(this.pager);
                this._toastrService.success(res.json().Result, '');
            },
            error => {
                this._mApp.HideLoader();
                this._toastrService.error(error.json().Result, '');
            }
            );
    }

    setPage(page: any) {
        this.pager.pageSize = page.pageSize;
        this.pager.pageIndex = page.pageIndex;
        this.GetComponentsList(this.pager);
    }

    GetComponentsList(page: any) {
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize
        this._mApp.ShowLoader();
        this._http.post(this._appUrl.GetComponentList, this.searchFields)
            .subscribe(
            res => {
                var data = res.json();
                this.length = data.PageResult.TotalRecords;
                this.pagedItems = data.Result;
                this.isNoRecords = !(data.Result.length > 0);
                this._mApp.HideLoader();
            },
            error => {
                this._mApp.HideLoader();
                this._toastrService.error(error.json().Result, '');
            }
            );
    }


    onSubmit() {
        this.isSubmitted = true;
        if (this.componentForm.valid) {
            let val = this.componentForm.value;
            this._mApp.ShowLoader();
            if(val.ComponentId==null||val.ComponentId==0)
            {
                val.ComponentId=0;
            }
            this._http.post(this._appUrl.UpsertComponent, val)
                .subscribe(
                data => {
                    this._mApp.HideLoader();
                    this._toastrService.success(data.json().Result);
                    $('#addComponentModel').modal('toggle');
                    this.Clear();
                    this.setPage(this.pager);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
                )
        }
    }


    // onSearchSubmit() {
    //     ;
    //     if (this.componentsSearchForm.valid) {
    //         let val = this.componentsSearchForm.value;
    //         alert(val.Component);
    //     }
    // }

    onSearchSubmit() {
        this.pager.pageIndex = 0;
        let searchDto = this.componentsSearchForm.value;
        if (searchDto.Name != null)
            this.searchFields.Name = searchDto.Name;
        this.setPage(this.pager);
    }

    Clear() {
        this.componentForm.reset();
        //this.CreateForm();
    }

    OnReset() {
        this.componentsSearchForm.reset();
        this.CreateForm();
        this.pager.pageSize = this._mApp.pageSize;
        this.pager.pageIndex = 0;
        this.searchFields.Name = '';
        this.setPage(this.pager);
    }

}